/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, Vue } from 'vue-property-decorator';
import { Stepper } from 'vant';
import { Toast } from '@hb/coffee';
import Field from '@/packages/field';
import { RouterV2Enum } from '@/router/router-names';
import ToolBoxApi from '@/api/toolBox';
import { ToolBoxVo } from '@/api/toolBox/types';

const style = require('./index.module.scss') as Dictionary;
const btnIcon = require('./image/btn1.png');

@Component({ name: 'ToolBox' })
export default class ToolBox extends Vue {
  // 错误信息
  private errorMsg: Dictionary<string> = {};

  private toolForm: ToolBoxVo = {
    loanAmt: 0,
    rate: '',
    periods: 0,
  };

  // 借款用途
  private use: string | number = '';

  // 期数
  private PositionDict = [
    { code: 3, name: '3期' },
    { code: 6, name: '6期' },
    { code: 9, name: '9期' },
    { code: 12, name: '12期' },
  ];

  // 用途
  private useList = [
    { code: 1, name: '个人消费' },
    { code: 2, name: '企业经营' },
  ];

  private onChange() {
    this.$ubtPageButton('贷款计算输入页_输入金额');
  }

  // 点击加
  private onPlus() {
    this.$ubtPageButton('贷款计算输入页_加');
  }

  // 点击减
  private onMinus() {
    this.$ubtPageButton('贷款计算输入页_减');
  }

  // 利率
  private onChangeRate() {
    this.$ubtPageButton('贷款计算输入页_输入利率');

    if (this.errorMsg.rate) {
      this.errorMsg.rate = '';
    }
  }

  // 期数
  private onChangeDate() {
    this.$ubtPageButton('贷款计算输入页_选择期数');
  }

  // 用途
  private onChangeUse() {
    this.$ubtPageButton('贷款计算输入页_选择用途');
  }

  // 正则校验
  private check(regNum: string) {
    return /^(?!0(\.0{1,2})?$)(\d(\.\d{1})?|10)$/.test(regNum);
  }

  // 计算
  private async onBtnClick() {
    if (!this.check(this.toolForm.rate)) {
      Toast('月利率只能输入0-10且保留一位小数！');
      this.$set(this.errorMsg, 'rate', '请重新输入');
      return;
    }

    // 埋点的数据要加上之前的值
    const objForm = {
      loanAmt: this.toolForm.loanAmt,
      periods: this.toolForm.periods,
      rate: `${this.toolForm.rate}`,
    };

    this.$ubtPageButton(
      '贷款计算输入页_计算',
      '借款期数',
      `${objForm.periods}期`,
      '借款金额',
      String(objForm.loanAmt),
      '月利率',
      objForm.rate,
    );

    try {
      const reslut = await ToolBoxApi.submintPayment(objForm);
      const resultObject = Object.assign(objForm, { amount: reslut });
      if (resultObject.amount) {
        this.$router.push({
          path: RouterV2Enum.toolBoxResult,
          query: {
            amount: resultObject.amount,
            loanAmt: `${resultObject.loanAmt}`,
            rate: `${resultObject.rate}`,
            periods: `${resultObject.periods}`,
          },
        });
      }
    } catch (error) {
      // console.log(e.msg);
    }
  }

  private render() {
    return (
      <div class={style.ToolBox}>
        <div class={style.bg}>
          <div class={style.main}>
            <div class={style.step}>
              <span>借款金额</span>
              <div class={style.right}>
                <Stepper
                  v-model={this.toolForm.loanAmt}
                  min="100"
                  max="200000"
                  integer={true}
                  step="100"
                  onChange={this.onChange}
                  onPlus={this.onPlus}
                  onMinus={this.onMinus}
                ></Stepper>
                <span>元</span>
              </div>
            </div>

            <div class={style.field}>
              <Field
                v-model={this.toolForm.rate}
                ref="field"
                type="text"
                label="月利率"
                placeholder="输入期望利率"
                onChange={this.onChangeRate}
                sub={false}
                error={this.errorMsg.rate}
              >
                <span slot="icon">%</span>
              </Field>
              <Field
                v-model={this.toolForm.periods}
                type="select"
                label="借款期数"
                placeholder="请选择借款期数"
                onChange={this.onChangeDate}
                sub={false}
                options={this.PositionDict}
              ></Field>
              <Field
                v-model={this.use}
                type="select"
                label="借款用途"
                placeholder="请选择借款用途"
                onChange={this.onChangeUse}
                sub={false}
                options={this.useList}
              ></Field>
            </div>

            <div class={style.btn} onClick={() => this.onBtnClick()}>
              <img src={btnIcon} width="100%" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
